import React from 'react';
import HeaderTemplate from './template';

const Header = () => {
  return <HeaderTemplate />;
};

export default Header;
